module.exports = __webpack_public_path__ + "static/media/pied-piper-alt.6742a0ce.svg";